"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformUserToJSON = exports.transformJSONToUser = void 0;

/* tslint:disable */

/* eslint-disable */

/**
 * Zeplin API
 * Access your resources in Zeplin
 *
 * Contact: support@zeplin.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var transformUserToJSON = function transformUserToJSON(value) {
  return {
    id: value.id,
    email: value.email,
    username: value.username,
    emotar: value.emotar,
    avatar: value.avatar,
    last_seen: value.lastSeen
  };
};

exports.transformUserToJSON = transformUserToJSON;

var transformJSONToUser = function transformJSONToUser(value) {
  return {
    id: value.id,
    email: value.email,
    username: value.username,
    emotar: value.emotar,
    avatar: value.avatar,
    lastSeen: value.last_seen
  };
};
/**
 * Basic info about Zeplin users.  Zeplin API does not expose any personal information to third-party clients. For this reason, the `email` field is a Zeplin-only alias by default.  You can get the original email addresses of members of your workspace by using a personal access token created with admin rights. Third-party (OAuth) applications are not allowed to access this information.  ☝️*Only organization admins (or higher) can retrieve the original email addresses using an admin token.* 
 * @export
 * @interface User
 */


exports.transformJSONToUser = transformJSONToUser;